import type { IconNode } from '../types';

/**
 * @name square-letter-p-off
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTJoMWEyIDIgMCAwMDAtNEg5LjVhLjUuNSAwIDAwLS41LjVWOSIgLz4KICA8cGF0aCBkPSJNMTUuMzQzIDIxSDVhMiAyIDAgMDEtMi0yVjguNjU3IiAvPgogIDxwYXRoIGQ9Ik0yMiAyMiAyIDIiIC8+CiAgPHBhdGggZD0iTTMuNTg2IDMuNTg2QTIgMiAwIDAxNSAzaDE0YTIgMiAwIDAxMiAydjE0YTIgMiAwIDAxLS41ODYgMS40MTQiIC8+CiAgPHBhdGggZD0iTTkgMTQuNjU3VjE2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/square-letter-p-off
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const SquareLetterPOff: IconNode = [
  ['path', { d: 'M12 12h1a2 2 0 000-4H9.5a.5.5 0 00-.5.5V9' }],
  ['path', { d: 'M15.343 21H5a2 2 0 01-2-2V8.657' }],
  ['path', { d: 'M22 22 2 2' }],
  ['path', { d: 'M3.586 3.586A2 2 0 015 3h14a2 2 0 012 2v14a2 2 0 01-.586 1.414' }],
  ['path', { d: 'M9 14.657V16' }],
];

export default SquareLetterPOff;
